import React, {PureComponent} from 'react';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import ui from 'redux-ui';
import {connect} from 'react-redux';
import EachAddressContent from "./EachAddressContent.jsx";
import ExpansionPanel from "housecall-ui/dist/DesignSystem/Surfaces/ExpansionPanels/ExpansionPanel"
import ExpansionPanelDetails from "housecall-ui/dist/DesignSystem/Surfaces/ExpansionPanels/ExpansionPanelDetails"
import ExpansionPanelSummary from "housecall-ui/dist/DesignSystem/Surfaces/ExpansionPanels/ExpansionPanelSummary"
import ExpandMoreIcon from 'housecall-ui/dist/IconsAndImages/Icons/ExpandMore'
import AddressTitle from "./AddressTitle.jsx";
import {findDOMNode} from 'react-dom';
import {DragSource, DropTarget} from 'react-dnd'
import Divider from "housecall-ui/dist/DesignSystem/DataDisplay/Divider/Divider"
import {ALLOW_ADDRESS_ROW_CLICK, UPDATE_EXPANDED_ADDRESS} from "./Redux/Actions";

const source = {
    isDragging(props, monitor) {
        return true
    },
    canDrag(props, monitor) {
        return !props.isHousecall && !props.isParent;
    },
    beginDrag(props) {
        return {
            index: props.index
        }
    }
};

const target = {
    canDrop(props, monitor) {
        return !props.isHousecall && !props.isParent;
    },
    hover(props, monitor, component) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;

        if (dragIndex === hoverIndex || props.isParent) {
            return;
        }

         props.fields.move(dragIndex, hoverIndex);
         props.updateBillingAddress(dragIndex, hoverIndex);

         monitor.getItem().index = hoverIndex;
         return props;
    },
};

function collect(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging(),
        connectDragPreview: connect.dragPreview()
    }
}

const styles = theme => ({
    expandPanel: {
        width: '100%',
    },
    summaryTitle: {
        padding: '0 16px 0 8px'
    },
    panelShadow: {
        boxShadow: 'none !important'
    },
    divider: {
        color: theme.palette.divider
    }
});

@DropTarget('ADDRESS', target, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget()
}))
@DragSource('ADDRESS', source, collect)
@ui({
    state: {
        allowRowClick: true
    },
    reducer: (state, action) => {
        switch (action.type) {
            case ALLOW_ADDRESS_ROW_CLICK:
                return state.set('allowRowClick', action.status)
        }
        return state;
    }
})
@connect(
    state => ({
        expandedAddress: state.addOrEditCustomer.expandedAddress
    }),
    dispatch => ({
        updateExpandedAddress: (key) => {
            dispatch({type: UPDATE_EXPANDED_ADDRESS, key: key})
        }
    })
)
@withStyles(styles)
export default class AddressExpansionPanel extends PureComponent {

    renderDivider() {
        if (this.props.index !== this.props.fields.length - 1 || this.props.isHousecall) {
            return <Divider className={this.props.classes.divider}/>
        }
    }

    shouldOpenAddressDetails() {
        return (!this.props.isHousecall && this.props.fields.length === 1) || this.props.expandedAddress === this.props.expandKey
    }

    renderExpansionContent() {
        if (this.shouldOpenAddressDetails()) {
            const { fields, index, address, isDragging,
                isHousecall, isParent } = this.props;
            return <EachAddressContent
                fields={fields}
                index={index}
                address={address}
                disableFields={isHousecall || isParent || isDragging}
                isHousecall={isHousecall}
            />
        }
    }

    draggablePreview() {
        const { classes, index, isHousecall, isParent,
            connectDragSource, connectDragPreview
        } = this.props;

        if (this.props.ui.showAllAddresses) {
            return <div className={classes.expandPanel}>
                <AddressTitle
                    index={index}
                    isHousecall={isHousecall}
                    isParent={isParent}
                />
            </div>;
        } else {
            return connectDragPreview(<div className={classes.expandPanel}>
                <AddressTitle
                    index={index}
                    connectDragSource={connectDragSource}
                    isHousecall={isHousecall}
                    isParent={isParent}
                />
            </div>);
        }
    }

    render() {
        const { expandKey, classes, connectDropTarget, isDragging, fields } = this.props;

        const targetContent = <ExpansionPanel
                classes={{root: classes.panelShadow}}
                expanded={this.shouldOpenAddressDetails()}
                onChange={(event, expanded) => {
                    if (this.props.ui.allowRowClick) {
                        this.props.updateExpandedAddress(expanded === false ? false : expandKey)
                    } else {
                        this.props.updateUI('allowRowClick', true);
                    }
                }}
            >
                <ExpansionPanelSummary classes={{root: classes.summaryTitle}} expandIcon={<ExpandMoreIcon />}>
                    {this.draggablePreview()}
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    {this.renderExpansionContent()}
                </ExpansionPanelDetails>
            </ExpansionPanel>;

        if (this.props.ui.showAllAddresses) {
            return <div className={classes.expandPanel}>
                {targetContent}
                {this.renderDivider()}
            </div>
        } else {
            return connectDropTarget(
                <div className={classes.expandPanel}>
                    {targetContent}
                    {this.renderDivider()}
                </div>
            )
        }
    }
}
